export enum AttractSource {
  EXCHANGE = 'exchange1',
  PAYMENT = 'payment1',
  REGISTER = 'register1',
  TASTE_REGISTER = 'taste-register',
  PERSON_PAYMENT = 'person-payment',
  TEAM_PAYMENT = 'team-payment2',
}
